import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import menu from 'data/menu'

export default function Toolbar({
    pathname
}) {

    return (
        <div className='md:hidden w-full bg-dark fixed bottom-0 left-0 drop-shadow-toolbar z-100 flex justify-between items-center px-6'>
            
            {menu?.map((item, index) => {

                const Icon = item.icon;
                let isActive = false;

                if (item.href === '/') {
                    isActive = pathname === item.href
                } else {
                    if (item.active) {
                        isActive = pathname.includes(item.active)
                    } else {
                        isActive = pathname.includes(item.href)
                    }
                }

                const ItemClasses = classNames({
                    'py-4 text-center': true,
                    'opacity-50': !isActive,
                    'opacity-100': isActive,
                })

                return (
                    <Link to={item.href} key={index} className={ItemClasses}>
                        <Icon className={`w-6 h-6 mx-auto mb-1 ${isActive ? 'fill-primary' : 'fill-lightprimary'}`}/>

                        <div className='text-toolbar text-white'>{item.label}</div>
                    </Link>
                )
            })}
        </div>
    )
}
